import { getAppsyncUrl } from "../authenticate";
import { getAuth } from '../../contexts/authStore';

export async function getAssignments(scheduleId: string, shiftId?: string, startDate?: string, endDate?: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getAssignments(scheduleId: ${JSON.stringify(scheduleId)}${shiftId ? ", shiftId: " + JSON.stringify(shiftId) : ''}
                ${startDate ? ", startDate: " + JSON.stringify(startDate) : ''}${endDate ? ", endDate: " + JSON.stringify(endDate) : ''})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getAssignments)
            })
        })
    }
}

export async function putAssignment(scheduleId: string, shiftId: string, date: string, assignees: string[]) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putAssignment(scheduleId: ${JSON.stringify(scheduleId)}, shiftId: ${JSON.stringify(shiftId)}, date: ${JSON.stringify(date)}, assignees: ${JSON.stringify(assignees)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putAssignment)
            })
        })
    }
}

export async function deleteAssignment(scheduleId: string, shiftId: string, date: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                deleteAssignment(scheduleId: ${JSON.stringify(scheduleId)}, shiftId: ${JSON.stringify(shiftId)}, date: ${JSON.stringify(date)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.deleteAssignment)
            })
        })
    }
}
